module.exports = __webpack_public_path__ + "static/media/slide-6.d4453523.jpg";